import { logger } from '../../helpers/logger'

export function logSending(msg) {
  const styles = [
    'background: linear-gradient(#426cf5, #323ea8)',
    // 'border: 1px solid #3E0E02',
    'color: white',
    'display: block',
    'text-shadow: 0 1px 0 rgba(0, 0, 0, 0.3)',
    'box-shadow: 0 1px 0 rgb(66, 236, 245) inset, 0 5px 3px -5px rgba(0, 0, 0, 0.5), 0 -13px 5px -10px rgba(255, 255, 255, 0.4) inset',
    'line-height: 30px',
    'text-align: center',
    'font-weight: bold',
  ].join(';')
  const parsed = JSON.parse(msg)
  logger.log(`%c ⬆️ ${parsed.service} ⬆️ ${msg} `, styles)
}

export function logRecevied(msg) {
  const styles = [
    'background: linear-gradient(#D62C36, #571402)',
    // 'border: 1px solid #3E0E02',
    'color: white',
    'display: block',
    'text-shadow: 0 1px 0 rgba(0, 0, 0, 0.3)',
    'box-shadow: 0 1px 0 rgba(255, 255, 255, 0.4) inset, 0 5px 3px -5px rgba(0, 0, 0, 0.5), 0 -13px 5px -10px rgba(255, 255, 255, 0.4) inset',
    'line-height: 30px',
    'text-align: center',
    'font-weight: bold',
  ].join(';')
  msg.service !== 'roundupdate' && logger.log(`%c ⬇️ ${msg.service} ⬇️ `, styles, msg)
}